// Source data for the IEM Starting Mix Cheat Sheet page.
// Straight transcription of the reference sheet handed to the tech/worship team.

export const mixProfiles = [
  {
    name: 'Acoustic',
    subtitle: 'Main refs: vocals + drums + bass',
    rows: [
      ['Click', '100%', 'C'],
      ['Talkback', '100%', 'C'],
      ['Acoustic — Self', '85%', 'L15'],
      ['Lead Vocal', '65%', 'C'],
      ['Other Vocals', '40%', 'L/R15'],
      ['Drums', '55%', 'Stereo'],
      ['Bass', '50%', 'C'],
      ['Piano', '45%', 'R20'],
      ['Electric', '35%', 'R30'],
      ['Synth', '25%', 'L25'],
      ['Cello', '25%', 'R10'],
    ],
  },
  {
    name: 'Bass',
    subtitle: 'Main ref: kick/drums',
    rows: [
      ['Click', '100%', 'C'],
      ['Talkback', '100%', 'C'],
      ['Bass — Self', '85%', 'C'],
      ['Kick / Drums', '70%', 'Stereo'],
      ['Lead Vocal', '55%', 'C'],
      ['Piano', '45%', 'R20'],
      ['Acoustic', '40%', 'L25'],
      ['Electric', '30%', 'R30'],
      ['Synth', '25%', 'L25'],
      ['Cello', '20%', 'R10'],
      ['Other Vocals', '25%', 'L/R15'],
    ],
  },
  {
    name: 'Drums',
    subtitle: 'Main refs: click + bass',
    rows: [
      ['Click', '100%', 'C'],
      ['Talkback', '100%', 'C'],
      ['Drums — Self', '80%', 'Stereo'],
      ['Bass', '70%', 'C'],
      ['Lead Vocal', '60%', 'C'],
      ['Acoustic', '45%', 'L25'],
      ['Piano', '45%', 'R20'],
      ['Electric', '35%', 'R30'],
      ['Synth', '25%', 'L25'],
      ['Cello', '25%', 'R10'],
      ['Other Vocals', '30%', 'L/R15'],
    ],
  },
  {
    name: 'Electric',
    subtitle: 'Hear the song + avoid doubling',
    rows: [
      ['Click', '100%', 'C'],
      ['Talkback', '100%', 'C'],
      ['Electric — Self', '85%', 'R15'],
      ['Lead Vocal', '65%', 'C'],
      ['Drums', '55%', 'Stereo'],
      ['Bass', '50%', 'C'],
      ['Acoustic', '45%', 'L30'],
      ['Piano', '40%', 'R10'],
      ['Synth', '35%', 'L20'],
      ['Cello', '25%', 'L10'],
      ['Other Vocals', '30%', 'L/R15'],
    ],
  },
  {
    name: 'Piano',
    subtitle: 'Hear vocals + synth space',
    rows: [
      ['Click', '100%', 'C'],
      ['Talkback', '100%', 'C'],
      ['Piano — Self', '85%', 'R15'],
      ['Lead Vocal', '65%', 'C'],
      ['Drums', '50%', 'Stereo'],
      ['Bass', '50%', 'C'],
      ['Acoustic', '40%', 'L25'],
      ['Synth', '45%', 'L25'],
      ['Electric', '30%', 'R30'],
      ['Cello', '35%', 'L10'],
      ['Other Vocals', '30%', 'L/R15'],
    ],
  },
  {
    name: 'Synth',
    subtitle: 'Hear piano + vocals',
    rows: [
      ['Click', '100%', 'C'],
      ['Talkback', '100%', 'C'],
      ['Synth — Self', '85%', 'L15'],
      ['Piano', '55%', 'R25'],
      ['Lead Vocal', '60%', 'C'],
      ['Drums', '45%', 'Stereo'],
      ['Bass', '45%', 'C'],
      ['Acoustic', '35%', 'L30'],
      ['Electric', '30%', 'R30'],
      ['Cello', '30%', 'R10'],
      ['Other Vocals', '25%', 'L/R15'],
    ],
  },
  {
    name: 'Strings / Cello',
    subtitle: 'Pitch + harmony references',
    rows: [
      ['Click', '100%', 'C'],
      ['Talkback', '100%', 'C'],
      ['Cello — Self', '85%', 'L10'],
      ['Lead Vocal', '65%', 'C'],
      ['Piano', '55%', 'R20'],
      ['Acoustic', '45%', 'L25'],
      ['Bass', '40%', 'C'],
      ['Drums', '35%', 'Stereo'],
      ['Synth', '35%', 'L25'],
      ['Electric', '25%', 'R30'],
      ['Other Vocals', '30%', 'L/R15'],
    ],
  },
  {
    name: 'Vocalist',
    subtitle: '*Lead singer adjusts other vocals',
    rows: [
      ['Click', '100%', 'C'],
      ['Talkback', '100%', 'C'],
      ['Own Vocal', '85%', 'C'],
      ['Lead Vocal*', '70%', 'C'],
      ['Other Vocals', '55%', 'L/R20'],
      ['Piano', '55%', 'R20'],
      ['Acoustic', '50%', 'L25'],
      ['Drums', '40%', 'Stereo'],
      ['Bass', '35%', 'C'],
      ['Electric', '25%', 'R30'],
      ['Synth / Cello', '25%', 'L25/L10'],
    ],
  },
];

export const defaultPanMap = [
  ['C', 'Click • Talkback • Bass • Lead Vocal'],
  ['Stereo', 'Drums'],
  ['L25', 'Acoustic'],
  ['L20–25', 'Synth'],
  ['L10', 'Cello'],
  ['R20', 'Piano'],
  ['R30', 'Electric'],
  ['L/R15–25', 'BGVs'],
];
